import request from '@/utils/request';

// 获取稿件统计数据
export function getArticleStatistic(data) {
  return request({
    url: '/yjrmzs/rmzs/app/articleStatistic',
    method: 'get',
    params: data,
    headers: {
      needToken: true
    }
  });
}
// 获取各频道的稿件统计数据
export function getChannelArticleStatisticList(data) {
  return request({
    url: '/yjrmzs/rmzs/app/channelArticleStatisticList',
    method: 'get',
    params: data,
    headers: {
      needToken: true
    }
  });
}
// 稿件列表
export function getArticleList(data) {
  return request({
    url: '/yjrmzs/rmzs/app/articleList',
    method: 'get',
    params: data,
    headers: {
      needToken: true
    }
  });
}
// 稿件列表
export function getMemberContributeLists(data) {
  return request({
    url: '/wap/ranking/get_member_contribute_lists',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取省市区
export function getPcd(data) {
  return request({
    url: '/wap/api/get_pcd',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
// 获取省市区
export function fill_address(data) {
  return request({
    url: '/wap/winning/fill_address',
    method: 'post',
    data: data,
    headers: {
      needToken: true
    }
  });
}
